var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-gray-300 hover:bg-secondary transition-colors",class:{
        'text-error': _vm.isInWishlist,
        'text-white': !_vm.isInWishlist,
        'cursor-pointer': !_vm.$store.state.wishlist.loading,
        'opacity-20 cursor-not-allowed': _vm.$store.state.wishlist.loading,
        'rounded-md py-3 px-5 lg:py-2 lg:px-4': !_vm.smallIcon,
        'p-4 rounded-l-lg': _vm.smallIcon,
    },attrs:{"type":"button","aria-label":_vm.$t('catalog.addtowishlist'),"disabled":_vm.$store.state.wishlist.loading},on:{"click":function($event){_vm.isInWishlist ? _vm.remove() : _vm.add()}}},[_c('HeartIcon',{staticClass:"w-8 h-8 block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }